import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/Index'
import Login from '@/pages/Login'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Login,
      meta: {
        title: '沉浸世界-登录'
      }
    },
    {
      path: '/Index',
      name: 'Index',
      component: Index,
      meta: {
        title: '沉浸世界-排场'
      }
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login,
      meta: {
        title: '沉浸世界-登录'
      }
    }
  ]
})

 // 路由导航守卫的语法   router对象.beforeEach((to, from, next) => {})
 router.beforeEach((to, from, next) => {
   // 如果用户访问的是 登录页面，则直接放行
   if (to.path === '/login') return next()
   // 获取 token
   const tokenStr = sessionStorage.getItem('m_token');
   // console.log("tokenStr"+tokenStr)
   // 如果 token 存在， 直接放行
   if (tokenStr) return next()
   // 否则，强制跳转到登录页
   next('/login')
 })
 router.beforeEach((to, from, next) => {
   /* 路由发生变化修改页面title */
   if (to.meta.title) {
     document.title = to.meta.title;
   }
   next();
 })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js